const getRepeatedValues = (list, fHash) => {
    const hash = fHash || (element => element);
    const seen = [];
    const repeatedValues = new Set();
    list.forEach(element => {
        const elementHash = hash(element);
        if (seen[elementHash]) {
            repeatedValues.add(element);
        } else {
            seen[elementHash] = true;
        }
    });
    return [...repeatedValues];
};

const excludeRepeatedValues = (list, fHash) => {
    const hash = fHash || (element => element);
    const resultList = [];
    const repeatedValues = {};
    list.forEach(element => {
        const elementHash = hash(element);
        if (repeatedValues[elementHash]) {
            // do nothing
        } else {
            resultList.push(element);
            repeatedValues[elementHash] = true;
        }
    });
    return resultList;
};

export { getRepeatedValues, excludeRepeatedValues };